import { ValidatorRule } from "rc-field-form/lib/interface";
export const isPositiveInteger =
  (name: string): ValidatorRule["validator"] =>
  async (_, value = "") => {
    if (value !== "" && !/^[1-9]\d*$/.test(value.toString()))
      return Promise.reject(new Error(`${name} must be a positive integer`));
    return Promise.resolve();
  };

export const isPositiveNumber =
  (name: string, label?: string): ValidatorRule["validator"] =>
  async (_, value = "") => {
    if (value === "" || value === null || Number(value) > 0) {
      return Promise.resolve();
    } else {
      return Promise.reject(new Error(`${label ? label : name} must be a positive number`));
    }
  };

export const isPositiveNumberOrZero =
  (name: string): ValidatorRule["validator"] =>
  async (_, value = "") => {
    if (value === "" || Number(value) >= 0) return Promise.resolve();
    return Promise.reject(new Error(`${name} must be a positive number`));
  };

export const isValidAddress =
  (
    latLng: StoreAddress["coordinate"] | null,
    setIsAddressValidated: React.Dispatch<React.SetStateAction<boolean>>
  ): ValidatorRule["validator"] =>
  async (_, value) => {
    if (!value) {
      setIsAddressValidated(false);
      return Promise.reject(new Error(`Address is required`));
    }
    if (latLng?.lat && latLng?.lng) {
      setIsAddressValidated(true);
      return Promise.resolve();
    } else {
      setIsAddressValidated(false);
      return Promise.reject(new Error(`Address is invalid`));
    }
  };
